import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { TageQuerySorterConfig } from 'fa-kt.types';
import { TageService } from '../service';

@Component({
  selector: 'fa-kt-tage-sorter',
  templateUrl: './tage-sorter.component.html',
  styleUrls: ['./tage-sorter.component.css'],
})
export class TageSorterComponent {
  public TageSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public tage: TageService,
  ) {
    this.TageSorterConfig = TageQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
